"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offchainProposal_1 = __importDefault(require("./offchainProposal"));
const initializer = __importStar(require("./offchainConfigManagerInitializer"));
class OffchainConfigManager {
    constructor(offchain) {
        this.proposals = {};
        this.metadataParameters = {
            rangeBegin: 0,
            rangeLength: 0,
            descending: true
        };
        this.proposalsData = {};
        this.getOffchain = () => this.offchain;
        // Fetchers
        this.fetchProposalsMetadata = initializer.fetchProposalsMetadata;
        this.getProposalsMetadata = initializer.getProposalsMetadata;
        this.fetchProposalData = initializer.fetchProposalData;
        this.getProposalData = initializer.getProposalData;
        this.offchain = offchain;
    }
    cleanCache() {
        this.proposalsMetadata = null;
        this.proposals = {};
        this.proposalsData = {};
    }
    getLatestProposals(rangeBegin = 0, rangeLength = 25) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getProposalsMetadata(rangeBegin, rangeLength, true);
        });
    }
    getProposal(proposalId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getProposalData(proposalId); // make sure the proposal data is initialized
            if (!this.proposals[proposalId])
                this.proposals[proposalId] = new offchainProposal_1.default(this, proposalId);
            return this.proposals[proposalId];
        });
    }
}
exports.default = OffchainConfigManager;
